export const storeEatData = [
    {
        "id": 1,
        "image": require("../images/store/store_01.jpeg"),
        "area": "歸仁區",
        "name": "蛋黃咖啡",
        "link": "https://egetbuy.pixnet.net/blog/post/364321597"
    },
    {
        "id": 2,
        "image": require("../images/store/store_02.jpeg"),
        "area": "中西區",
        "name": "張合豐排骨飯",
        "link": "https://lincyi.pixnet.net/blog/post/33776396"
    },
    {
        "id": 3,
        "image": require("../images/store/store_03.jpeg"),
        "area": "佳里區",
        "name": "嗜麻殿",
        "link": "https://kwyt.pixnet.net/blog/post/92061046"
    },
    {
        "id": 4,
        "image": require("../images/store/store_04.jpeg"),
        "area": "中西區",
        "name": "林家楊桃湯",
        "link": "https://asdfghjkl0905.pixnet.net/blog/post/50325460"
    },
    {
        "id": 5,
        "image": require("../images/store/store_05.jpeg"),
        "area": "西港區",
        "name": "南風冰菓室",
        "link": "https://cchuang1206.pixnet.net/blog/post/221799796"
    },
    {
        "id": 6,
        "image": require("../images/store/store_06.jpeg"),
        "area": "安南區",
        "name": "北安利多無名紅豆餅",
        "link": "https://suting16.pixnet.net/blog/post/340286001"
    },
    {
        "id": 7,
        "image": require("../images/store/store_07.jpeg"),
        "area": "中西區",
        "name": "懷舊小棧杏仁豆腐冰",
        "link": "https://love1980521.pixnet.net/blog/post/70410987"
    },
    {
        "id": 8,
        "image": require("../images/store/store_08.jpeg"),
        "area": "南區",
        "name": "夏林臭豆腐",
        "link": "https://hsia951103.pixnet.net/blog/post/91012105"
    },
    {
        "id": 9,
        "image": require("../images/store/store_09.jpeg"),
        "area": "學甲區",
        "name": "順德土產牛肉",
        "link": "https://penny2984.pixnet.net/blog/post/50359836"
    },
    {
        "id": 10,
        "image": require("../images/store/store_10.jpeg"),
        "area": "中西區",
        "name": "LULU&BUN麵包店",
        "link": "https://jilltrip.pixnet.net/blog/post/340335450"
    }
];
